




































































































































































import {
    Component, Vue, Watch, Prop,
} from 'vue-property-decorator';
import { upload } from '@/plugins/papybase/papybaseInit';
import { ImageInfo } from '@luxtag/papybase';
import FileUpload from 'vue-upload-component';
import Compressor from 'compressorjs';
import Papa from 'papaparse';
import moment, { months } from 'moment';
import SimpleDialog from '@/components/global/SimpleDialog.vue';
import { map } from 'lodash';
import { CSVFile, CSVData } from '../../../store/modules/csv';

const uuidv4 = require('uuid/v4');

@Component({
    components: {
        FileUpload,
        SimpleDialog,
    },
})
export default class InsertFileDialogUpload extends Vue {
    @Prop() readonly dialogStatus!: boolean;

    public showUploadFailedDialog = false;
    public showWrongFileDialog = false;

    public errorMessage = ''

    public uploadDropZoneId = 'insert_photo_dialog_upload_555';

    public isDropOnUploadZone = false;

    public files = [];

    public uploadButtonHover = false;

    public headers: string[] = [];

    public fileUploadProperties = {
        accept: 'text/csv',
        extensions: 'csv',
        multiple: false,
        maximum: 1,
        minSize: 1024,
        size: 1024 * 1024 * 10,
        autoCompress: 1024 * 1024,
        drop: true,
        postAction: '/upload/post',
        putAction: '/upload/put',
        name: 'csv',
    }

    public created() {
        this.preventDrop();
    }

    public inputFilter(newFile: any, oldFile: any, prevent: any) {
        const that = this;
        if (newFile && !oldFile) {
            // Before adding a file
            // Filter csv file
            if (!/\.(csv)$/i.test(newFile.name)) {
                this.showWrongFileDialog = true;
                // this.showError('Your choice is not a CSV file');
                return prevent();
            }

            // Filter system files or hide files
            if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                return prevent();
            }

            // Filter php html js file
            if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                return prevent();
            }

            this.parseCsvFile(newFile);
        }
    }

    public inputFile(newFile: any, oldFile: any) {
        if (newFile && !oldFile) {
            // add
            // console.log('add', newFile);
        }
        if (newFile && oldFile) {
            // update
            // console.log('update', newFile);
        }
        if (!newFile && oldFile) {
            // remove
            // console.log('remove', oldFile);
        }
    }

    public parseCsvFile(csvFile: any) {
        const that = this;
        this.headers = [];
        // Parse local CSV file
        Papa.parse(csvFile.file, {
            header: true,
            transformHeader: (input) => {
                that.headers.push(input);
                return input;
            },
            comments: '#',
            complete(results) {
                that.processCSVFile(csvFile.file.name, results);
            },
            error(err: any, file: any) {
                console.error(`${err.message} on row ${err.row}`);
            },
        });
    }

    public processCSVFile(name: string, results: Papa.ParseResult) {
        const dataResult: CSVData[] = results.data;
        const indexedDataResult = map(dataResult, (item, index) => ({
            id: index,
            ...item,
        }));
        const theCsvFile: CSVFile = {
            uid: uuidv4(),
            name,
            headers: this.headers,
            data: indexedDataResult,
            createdAt: moment().format(),
            updatedAt: moment().format(),
        };
        this.filterParsedCsfFile(theCsvFile);
    }

    public filterParsedCsfFile(csvFile: CSVFile) {
        const firstData: any = csvFile.data[0];
        if (!firstData.Model) {
            this.showError('We can not find "Model" on header');
            return;
        }

        if (!firstData['Serial No.']) {
            this.showError('We can not find "Serial No." on header');
            return;
        }

        this.$emit('uploadFinish', csvFile);
        this.headers = [];
    }

    public emitCSVFile(csvFile: any) {
    }

    public showError(message: string) {
        this.errorMessage = message;
        this.showUploadFailedDialog = true;
    }

    private preventDrop() {
        window.addEventListener('dragenter', (e: any) => {
            this.preventDropCondition(e);
        }, false);

        window.addEventListener('dragover', (e: any) => {
            this.preventDropCondition(e);
        }, false);
        window.addEventListener('drop', (e) => {
            this.preventDropCondition(e);
        }, false);
    }

    private preventDropCondition(e: any) {
        if (e.target.id !== this.uploadDropZoneId) {
            this.isDropOnUploadZone = false;
            e.preventDefault();
            e.dataTransfer.effectAllowed = 'none';
            e.dataTransfer.dropEffect = 'none';
        } else {
            this.isDropOnUploadZone = true;
        }
    }

    @Watch('dialogStatus')
    private onCheckDialogChanged(val: boolean, oldVal: boolean) {
        if (!val) {
            this.files = [];
        }
    }
}
